import { createStore,applyMiddleware,compose } from "redux";
import allReducrs from "./reducres/index";
import thunk from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(allReducrs,composeEnhancers(applyMiddleware(thunk)));

export default store;